import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select, Card, Row, Col } from 'react-bootstrap';
import { oneKlicks } from '../../../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../../../SDK/OneKlicksFileSDK';
import ImageShow from '../../../../Uitiles/ImageShow';
import { getuserdata } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { debugLog } from '../../../../utils/debug';

const ViewAiService = ({ openView, setOpenView, selectedService }) => {
    const handleClose = () => {
        setOpenView(false);
    };

    return (
        <Modal show={openView} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>View AI Service</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {selectedService ? (
                    <div>
                        <Row>
                            <Col md={4}>
                                <Card className="mb-3">
                                    <Card.Body className="text-center">
                                        <ImageShow 
                                            url={selectedService.image} 
                                            width={200} 
                                            height={200} 
                                            style={{ 
                                                objectFit: 'cover', 
                                                borderRadius: '10px',
                                                width: '100%',
                                                height: '200px'
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={8}>
                                <Card>
                                    <Card.Body>
                                        <h5 className="card-title mb-3">{selectedService.name}</h5>
                                        
                                        <div className="mb-3">
                                            <strong>Description:</strong>
                                            <p className="mt-2">{selectedService.description}</p>
                                        </div>
                                        
                                        <div className="mb-3">
                                            <strong>Page Link:</strong>
                                            <p className="mt-2">
                                                <a 
                                                    href={selectedService.pageLink} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="text-primary"
                                                >
                                                    {selectedService.pageLink}
                                                </a>
                                            </p>
                                        </div>
                                        
                                        <div className="mb-3">
                                            <strong>Status:</strong>
                                            <span className={`badge ms-2 ${selectedService.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                                                {selectedService.status}
                                            </span>
                                        </div>
                                        
                                        <div className="mb-3">
                                            <strong>Service ID:</strong>
                                            <p className="mt-2 text-muted">{selectedService.id}</p>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <div className="text-center py-4">
                        <p>No service data available</p>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewAiService;
